import { Component } from 'react'
class SectionCRING extends Component {

    state= {
        content: [
            { 
                emoji: "🔍",
                name: "Explorer",
                link: ["https://explorer.bitquery.io/bsc/token/0x147c8eb766c6101480bef172a573e04b400b8d9f"],
                linkTitle: ["Bitquery"],
                indications:""
            },
            { 
                emoji: "📃",
                name: "Contract",
                link: ["https://bscscan.com/address/0x147c8eb766c6101480bef172a573e04b400b8d9f"],
                linkTitle: ["BscScan"],
                indications:""
            },
            { 
                emoji: "💲",
                name: "Token",
                link: ["https://bscscan.com/token/0x147c8eb766c6101480bef172a573e04b400b8d9f"],
                linkTitle: ["BscScan"],
                indications:""
            },
            { 
                emoji: "💸",
                name: "Trade",
                link: ["https://dex.guru/token/0x147c8eb766c6101480bef172a573e04b400b8d9f-bsc",
                        "https://exchange.pancakeswap.finance/#/swap"],
                        linkTitle: ["dex.guru","PancakeSwap"],
                indications:`Add address "0x147c8eb766c6101480bef172a573e04b400b8d9f" to "Select a token" and set SLIPPAGE 12% in the options.`
            },
            { 
                emoji: "🧫",
                name: "Liquidity pool",
                link: ["https://exchange.pancakeswap.finance/#/add/BNB"],
                linkTitle: ["PancakeSwap"],
                indications: `Add  address "0x147c8eb766c6101480bef172a573e04b400b8d9f" to "Select a currency".`
            },
            { 
                emoji: "🔒",
                name: "Liquidity lock",
                link: ["https://bscscan.com/address/0x12d25916Cc468b3824503DaED68476B6303FA76D"],
                linkTitle: ["Timelock Contract"],
                indications:""
            },
            { 
                emoji: "📈",
                name: "Chart",
                link: ["https://charts.bogged.finance/?token=0x147c8eb766c6101480bef172a573e04b400b8d9f",
                        "https://poocoin.app/tokens/0x147c8eb766c6101480bef172a573e04b400b8d9f"],
                        linkTitle: ["BoggedFinance","PooCoin"],
                indications:""
            },
            { 
                emoji: "🔥",
                name: "Staking",
                link: ["https://stak.cbase.ctena.finance/"],
                linkTitle: ["Stake CRING-BNB CAKELP"],
                indications:""
            },
        ]
    }

     copyToClipboard = (e) => {
        const el = document.createElement('textarea');
        el.value = "0x147c8eb766c6101480bef172a573e04b400b8d9f";
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        e.target.innerHTML=" Copied! :)";
        setTimeout(() => {
            e.target.innerHTML=" Copy Address";  
        }, 3000);
      };
      
    render () {
        return (
            <div className="section-wrap" id="cring-wrap">
                <p id="faq-title">CRING</p>
                <div id="intro-buttons">
                <a href="https://ring.ctena.finance"><button>Dashboard</button></a>
                <a href="https://stak.ring.ctena.finance"><button>Staking</button></a>
                <a href="https://swap.arken.finance/tokens/bsc/0x147c8eb766c6101480bef172a573e04b400b8d9f"><button>Buy</button></a>
                <a href="https://pancakeswap.finance/add/BNB/0x147c8eb766c6101480bef172a573e04b400b8d9f"><button>Add Liquidity</button></a>
                </div>
                <div className="section-wrap" id="intro-wrap">


                <div id="info-txt">
                    <p>
                    <span>CRING</span> is an elastic supply token that is mathematically guaranteed to increase in price until it exceeds the price of an index based compose 70% BTC and 30% ETH.
                    </p>
                </div>
                <div id="info-txt">
                    <p> <span>Increasing Peg Price</span> </p>
                    <p>For 360 epoch, CRING will increase 5% every 4 hours, starting for an initial peg price of $0.000000440918.
                    </p>
                   
                </div>
                <div id="info-txt">
                    <p> <span>Dynamic rebases</span> </p>
                    <p>Negative rebases are amplified to make CRING return into positive rebase territory faster. This prevents long periods of negative rebases. Rebases can also be triggered up to 6 times per day, resulting in a token that maintains its peg very efficiently.

                    </p>
                   
                </div>
        
                <div id="info-txt">
                    <p> <span>Trustless oracles</span> </p>
                    <p>
Ditto uses time-weighted average price (TWAP) price feeds generated by on-chain AMMs. There is no dependence on external Oracles that could be manipulated.
                    </p>
                   
                </div>
          

            </div>
                { this.state.content.map( (box, index) => (
                    <div key={index} className="question-box">
                        <p className="question-q"><span className="question-q1">{box.emoji}</span>
                            <span className="question-q2">{box.name}</span>
                            {(box.indications === "")? null : <span class="copy-address-button" onClick={e => this.copyToClipboard(e)}> Copy Address </span>}
                        </p>
                        <div  className="question-boxForButtons">
                            {box.link.map( (link, index) => <a href={link} target="_blank"><button key={index}> {box.linkTitle[index]}</button> </a>)}
                        </div>
                        {(box.indications === "")? null : <p key={index} className="question-indications"> {box.indications}</p>}
                    </div>
                ))
                }
                

                

          

            </div>
  
        )
    }
}

export default SectionCRING
